module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-index"
  }, [(_vm.showFilterBarFlag) ? _c('div', {
    staticClass: "nav-div"
  }, [_c('nav', {
    staticClass: "bar bar-nav merbar",
    staticStyle: {
      "padding-left": "0rem",
      "padding-right": "0rem"
    }
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0rem",
      "margin-bottom": "0rem"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("为您找到"), _c('span', {
    staticStyle: {
      "color": "#0a8ddf"
    }
  }, [_vm._v(_vm._s(_vm.queryTotal.total))]), _vm._v("条结果")]), _vm._v(" "), (!_vm.showFilterBarForKit) ? _c('div', {
    staticStyle: {
      "color": "#0a8ddf",
      "float": "right"
    }
  }, [_c('a', {
    staticClass: "pull-right open-panel",
    on: {
      "click": function($event) {
        return _vm.openshaxuan()
      }
    }
  }, [_vm._v("筛选")])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (Number(this.$route.query.id) === 5 || Number(this.$route.query.id) === 8 || Number(this.$route.query.id) === 14 || Number(this.$route.query.id) === 7 || Number(this.$route.query.id) === 9 || this.$route.name === 'searchresults') ? _c('div', {
    staticStyle: {
      "height": "2.2rem"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0rem"
    }
  }, [_c('ul', {
    staticClass: "list-container",
    staticStyle: {
      "border-top": "0px solid #e7e7e7"
    }
  }, _vm._l((_vm.merchListWithoutCustomized10), function(pro) {
    return _c('li', [(_vm.description === 'group') ? _c('div', {
      staticStyle: {
        "padding-left": ".5rem"
      }
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem"
      },
      on: {
        "click": function($event) {
          return _vm.clickMerchandise(pro)
        }
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [(pro.bpromotions && pro.bpromotions.length > 0 && pro.bpromotions[0].requiredCustomers === 0 && pro.bpromotions[0].type !== 0 && pro.bpromotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.bpromotions[0].name) + "\n                     ")])]) : _vm._e(), _vm._v(" "), (pro.promotions && pro.promotions.length > 0 && pro.promotions[0].requiredCustomers === 0 && pro.promotions[0].type !== 0 && pro.promotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.promotions[0].name) + "\n                       ")])]) : _vm._e(), _vm._v(" "), (pro.bpromotions && pro.bpromotions.length > 0 && pro.bpromotions[0].type === 6) ? _c('div', {
      staticClass: "item-after"
    }, [_c('img', {
      attrs: {
        "src": "/emktResources/resocurces/img/promotion/miaosha_mobile.png",
        "alt": "秒杀进行/预告",
        "height": "30px"
      }
    })]) : _vm._e(), _vm._v(" "), (pro.promotions && pro.promotions.length > 0 && pro.promotions[0].type === '6') ? _c('div', {
      staticClass: "item-after"
    }, [_c('img', {
      attrs: {
        "src": "/emktResources/resocurces/img/promotion/miaosha_mobile.png",
        "alt": "秒杀进行/预告",
        "height": "30px"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, _vm._l((pro._titleList), function(title) {
      return _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, [_vm._l((pro._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])])])])
    }), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [(subTitle.valueText && subTitle.valueText.length > 15) ? _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText.substring(0, 15)) + "...")]) : _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "item-text",
      staticStyle: {
        "height": "2rem"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMax))]) : _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [(pro.categoryId === 20) ? _c('span', [_vm._v("¥" + _vm._s(Math.floor(pro.priceMin)) + "起")]) : _c('span', [_vm._v("¥" + _vm._s(pro.priceMin))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [(pro.categoryId === 20) ? _c('span', [_vm._v("周期" + _vm._s(pro.cycle) + "工作日起")]) : _c('span', [_vm._v("周期" + _vm._s(pro.cycle) + "工作日")])])])]), _vm._v(" "), (pro.totalSales === pro.salesLimit && pro.salesLimit !== -1) ? _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [_c('span', {
      staticClass: "sub-span",
      staticStyle: {
        "background-color": "#FF9400"
      }
    }, [_vm._v("缺货")]), _vm._v(" "), (pro.selfOperated === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("代购")]) : _vm._e()]) : _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [(pro.stockOrCustomized === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("现货")]) : _vm._e(), _vm._v(" "), (pro.stockOrCustomized === 1) ? _c('span', {
      staticClass: "sub-span",
      staticStyle: {
        "background-color": "#ff0000"
      }
    }, [_vm._v("定制")]) : _vm._e(), _vm._v(" "), (pro.selfOperated === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("代购")]) : _vm._e()]), _vm._v(" "), (_vm.showInventoryStockRemark(pro)) ? _c('div', {
      staticStyle: {
        "float": "left",
        "font-size": ".5rem"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.inventoryStockRemark))])]) : _vm._e()]), _vm._v(" "), _c('div', _vm._l((pro._specificatList), function(specificat) {
      return (pro._specificatList && pro._specificatList.length > 0) ? _c('span', {
        staticStyle: {
          "margin-left": "3px",
          "font-size": "small",
          "color": "#4479B4"
        }
      }, [_vm._v(_vm._s(specificat.label) + ": " + _vm._s(specificat.valueText))]) : _vm._e()
    }), 0), _vm._v(" "), (pro._attributes.Product_Master && pro._attributes.Product_Master.value !== 'Customize') ? _c('div', {
      staticStyle: {
        "font-size": ".4rem",
        "color": "rgb(29, 102, 225)"
      }
    }, [_vm._v(_vm._s(pro._attributes.Product_Master.value))]) : _vm._e()])])]) : _c('div', {
      staticStyle: {
        "padding-left": ".5rem"
      }
    }, [(!pro.composite) ? _c('div', [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem"
      },
      on: {
        "click": function($event) {
          return _vm.clickMerchandise(pro)
        }
      }
    }, [(_vm.filteredShowPromotions(pro) && _vm.filteredShowPromotions(pro).length > 0) ? _c('div', {
      staticClass: "item-title-row"
    }, [_c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(_vm.filteredShowPromotions(pro)[0].name))])]), _vm._v(" "), (_vm.filteredShowPromotions(pro)[0].type === 6) ? _c('div', {
      staticClass: "item-after"
    }, [(_vm.secFlag !== 2) ? _c('img', {
      attrs: {
        "src": "/emktResources/resocurces/img/promotion/miaosha_mobile.png",
        "alt": "秒杀进行/预告",
        "height": "30px"
      }
    }) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, _vm._l((pro._titleList), function(title) {
      return _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, [_vm._l((pro._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])])])])
    }), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [(subTitle.valueText && subTitle.valueText.length > 15) ? _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText.substring(0, 15)) + "...")]) : _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "item-text",
      staticStyle: {
        "height": "2rem"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMax))]) : _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [(pro.categoryId === 20) ? _c('span', [_vm._v("¥" + _vm._s(Math.floor(pro.priceMin)) + "起")]) : _c('span', [_vm._v("¥" + _vm._s(pro.priceMin))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [(pro.categoryId === 20) ? _c('span', [_vm._v("周期" + _vm._s(pro.cycle) + "工作日起")]) : _c('span', [_vm._v("周期" + _vm._s(pro.cycle) + "工作日")])])])]), _vm._v(" "), (pro.totalSales === pro.salesLimit && pro.salesLimit !== -1) ? _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [_c('span', {
      staticClass: "sub-span",
      staticStyle: {
        "background-color": "#FF9400"
      }
    }, [_vm._v("缺货")]), _vm._v(" "), (pro.selfOperated === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("代购")]) : _vm._e()]) : _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [(pro.stockOrCustomized === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("现货")]) : _vm._e(), _vm._v(" "), (pro.stockOrCustomized === 1) ? _c('span', {
      staticClass: "sub-span",
      staticStyle: {
        "background-color": "#ff0000"
      }
    }, [_vm._v("定制")]) : _vm._e(), _vm._v(" "), (pro.selfOperated === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("代购")]) : _vm._e()]), _vm._v(" "), (_vm.showInventoryStockRemark(pro)) ? _c('div', {
      staticStyle: {
        "float": "left",
        "font-size": ".5rem"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.inventoryStockRemark))])]) : _vm._e()])]), _vm._v(" "), (pro._attributes.Product_Master && pro._attributes.Product_Master.value !== 'Customize') ? _c('div', {
      staticStyle: {
        "font-size": ".4rem",
        "margin-bottom": ".5rem",
        "color": "rgb(29, 102, 225)"
      }
    }, [_vm._v(_vm._s(pro._attributes.Product_Master.value))]) : _vm._e()])]) : _c('div', [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem"
      },
      on: {
        "click": function($event) {
          return _vm.setdatas(pro)
        }
      }
    }, [(_vm.filteredShowPromotions(pro) && _vm.filteredShowPromotions(pro).length > 0) ? _c('div', {
      staticClass: "item-title-row"
    }, [_c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(_vm.filteredShowPromotions(pro)[0].name))])]), _vm._v(" "), (_vm.filteredShowPromotions(pro)[0].type === 6) ? _c('div', {
      staticClass: "item-after"
    }, [(_vm.secFlag !== 2) ? _c('img', {
      attrs: {
        "src": "/emktResources/resocurces/img/promotion/miaosha_mobile.png",
        "alt": "秒杀进行/预告",
        "height": "30px"
      }
    }) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, _vm._l((pro._titleList), function(title) {
      return _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, [_vm._l((pro._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])])])])
    }), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [(subTitle.valueText && subTitle.valueText.length > 15) ? _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText.substring(0, 15)) + "...")]) : _c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "item-text",
      staticStyle: {
        "height": "2rem"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(pro.priceMin !== pro.priceMax) ? _c('span', [_vm._v("\n                       ¥" + _vm._s(pro.priceMin) + " ~ ¥" + _vm._s(pro.priceMax) + "\n                    ")]) : _c('span', [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMax))]) : _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [(pro.categoryId === 20) ? _c('span', [_vm._v("¥" + _vm._s(Math.floor(pro.priceMin)) + "起")]) : _c('span', [_vm._v("¥" + _vm._s(pro.priceMin))])])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [(pro.categoryId === 20) ? _c('span', [_vm._v("周期" + _vm._s(pro.cycle) + "工作日起")]) : _c('span', [_vm._v("周期" + _vm._s(pro.cycle) + "工作日")])])])]), _vm._v(" "), (pro.totalSales === pro.salesLimit && pro.salesLimit !== -1) ? _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [_c('span', {
      staticClass: "sub-span",
      staticStyle: {
        "background-color": "#FF9400"
      }
    }, [_vm._v("缺货")])]) : _c('div', {
      staticStyle: {
        "float": "right",
        "font-size": ".5rem"
      }
    }, [(pro.stockOrCustomized === 0) ? _c('span', {
      staticClass: "sub-span"
    }, [_vm._v("现货")]) : _vm._e(), _vm._v(" "), (pro.stockOrCustomized === 1) ? _c('span', {
      staticClass: "sub-span",
      staticStyle: {
        "background-color": "#ff0000"
      }
    }, [_vm._v("定制")]) : _vm._e()]), _vm._v(" "), (_vm.showInventoryStockRemark(pro)) ? _c('div', {
      staticStyle: {
        "float": "left",
        "font-size": ".5rem"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.inventoryStockRemark))])]) : _vm._e()])]), _vm._v(" "), (pro._attributes.Product_Master && pro._attributes.Product_Master.value !== 'Customize') ? _c('div', {
      staticStyle: {
        "font-size": ".4rem",
        "color": "rgb(29, 102, 225)"
      }
    }, [_vm._v(_vm._s(pro._attributes.Product_Master.value))]) : _vm._e()])])])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5be295a9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finder/components/NewMerchandiseListA.vue
// module id = 1650
// module chunks = 8